export function Bell() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentcolor"
    >
      <path d="M12.9998 1.5V2.33813C16.3983 2.87766 18.9998 5.82187 18.9998 9.375V10.9406C18.9998 13.0687 19.7264 15.1359 21.053 16.8L21.7514 17.6719C22.0233 18.0094 22.0748 18.4734 21.8873 18.8625C21.6998 19.2516 21.3061 19.5 20.8748 19.5H2.12483C1.69217 19.5 1.29818 19.2516 1.11087 18.8625C0.923513 18.4734 0.9762 18.0094 1.24639 17.6719L1.94529 16.8C3.27514 15.1359 3.99983 13.0687 3.99983 10.9406V9.375C3.99983 5.82187 6.60139 2.87766 9.99983 2.33813V1.5C9.99983 0.671719 10.6701 0 11.4998 0C12.3295 0 12.9998 0.671719 12.9998 1.5ZM11.1248 4.5C8.4342 4.5 6.24983 6.68437 6.24983 9.375V10.9406C6.24983 13.1859 5.5992 15.375 4.38936 17.25H18.6108C17.4014 15.375 16.7498 13.1859 16.7498 10.9406V9.375C16.7498 6.68437 14.5655 4.5 11.8748 4.5H11.1248ZM14.4998 21C14.4998 21.7547 14.1858 22.5609 13.6233 23.1234C13.0608 23.6859 12.2545 24 11.4998 24C10.703 24 9.93889 23.6859 9.37639 23.1234C8.81389 22.5609 8.49983 21.7547 8.49983 21H14.4998Z" />
    </svg>
  );
}
